import { useEffect, useState, useCallback } from "react";
import dayjs from "@/lib/day";
import styles from "@/styles/Video.module.scss";
import { Button } from "@/components/Buttons";

const formatCountDown = function (diff) {
  if (diff > 0) {
    if (diff >= 86400) {
      return `${Math.floor(diff / 86400)}日`;
    }
    let format = "H時間";
    if (diff < 3600) {
      format = "m分";
    }
    if (diff < 300) {
      format = "m分s秒";
    }
    if (diff < 60) {
      format = "s秒";
    }
    return dayjs.unix(diff).utc().format(format);
  }
  return "00:00:00";
};

export default function LiveBefore({
  watch,
  state,
  isChatAvailableMeta,
  setChatDisplay,
}) {
  const calculateTimeLeft = useCallback(() => {
    const now = dayjs();
    const startDate = dayjs(new Date(watch.episode.delivery_start_at));
    return startDate.diff(now, "seconds");
  }, []);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  });

  useEffect(() => {
    if (timeLeft <= 0) {
      state.reset();
    }
  }, [timeLeft]);

  return (
    <div className={styles.livebefore}>
      <div>
        <div>配信まで</div>
        <div className={styles.timeleft}>{formatCountDown(timeLeft)}</div>
      </div>
      {isChatAvailableMeta && (
        <Button fillColor medium onClick={() => setChatDisplay(true)}>
          チャット表示
        </Button>
      )}
    </div>
  );
}
